var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5219 10.4463L20.137 11.7762V11.7777L20.8157 12.5615H20.817L28.3 11.8876H28.3045L28.4158 11.8785H28.4279L28.4986 11.8921V11.8891L28.5407 11.9011L28.5422 11.9026L34.3659 13.0294L27.0426 20.273L27.0423 20.2748L27.0414 20.2742L27.0408 20.2748L27.0409 20.2738L26.7444 20.0762L22.6554 22.5239L20.5432 19.503L20.3656 19.6504L19.5623 20.3229L20.3732 19.6504L19.7864 22.1448H19.7879L23.8559 26.139L23.8529 26.142C22.4508 27.2944 20.6575 27.991 18.7017 28H18.6792H18.6656C16.7099 27.991 14.9166 27.2959 13.5145 26.142C13.5145 26.139 13.5115 26.139 13.5115 26.139L17.5809 22.1433L16.9942 19.6489L17.8051 20.3214L17.0032 19.6489L16.8257 19.5015L14.7135 22.5224L10.6245 20.0747L10.3266 20.2732L9.42774 14.8509L10.2168 19.6203L10.3251 20.2732L3 13.0279L8.93498 11.8785H8.94701L9.05834 11.8876H9.06285L16.5459 12.5615H16.5486L18.6325 10.0416C18.6325 10.0416 22.7366 9.80841 23.5219 10.4463ZM8.944 11.9268V11.9206L8.94099 11.9086L8.944 11.9268Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbLogo);
export default __webpack_public_path__ + "static/media/BBLogo.27d68e8ef6cac2fa7a115aa256568482.svg";
export { ForwardRef as ReactComponent };